import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-secondary text-white pt-20 pb-8" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-93">
          {/* Col 1: Bio */}
          <div data-id="element-94">
            <div className="mb-6" data-id="element-95">
              <button onClick={() => onNavigate?.('home')} className="cursor-pointer" data-id="element-96">
                <img src="https://cdn.magicpatterns.com/uploads/9X9TPfvH9ot6QAJ7Jk3ZEk/ChatGPT_Image_Mar_9,_2026,_12_42_44_PM.png" alt="Uzoka Tow Truck Service — Go to Homepage" className="h-20 w-auto object-contain" data-id="element-97" />
              </button>
            </div>
            <p className="text-white/70 leading-relaxed text-lg" data-id="element-98">
              Providing rapid, reliable, and professional towing and roadside
              assistance. Our zero-queue digital dispatch ensures you're never
              left waiting.
            </p>
          </div>

          {/* Col 2: Services */}
          <div data-id="element-99">
            <h4 className="text-xl font-bold mb-6" data-id="element-100">Services</h4>
            <ul className="space-y-4" data-id="element-101">
              {['Emergency Towing', 'Roadside Assistance', 'Fuel Delivery', 'Battery Jump Start', 'Lockout Service'].map(item => <li key={item} data-id="element-102">
                  <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-103">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Quick Links */}
          <div data-id="element-104">
            <h4 className="text-xl font-bold mb-6" data-id="element-105">Quick Links</h4>
            <ul className="space-y-4" data-id="element-106">
              {['Customer Portal', 'Careers', 'Service Areas', 'Contact Us'].map(item => <li key={item} data-id="element-107">
                  <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-108">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 4: Legal & Compliance */}
          <div data-id="element-109">
            <h4 className="text-xl font-bold mb-6" data-id="element-110">Legal</h4>
            <ul className="space-y-4 mb-8" data-id="element-111">
              {['Privacy Policy', 'Terms of Service', 'Accessibility Statement'].map(item => <li key={item} data-id="element-112">
                  <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-113">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full border border-white/20" data-id="element-114">
              <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-115" />
              <span className="text-xs font-medium" data-id="element-116">WCAG 2.1 AA Compliant</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 text-center text-white/50 text-base" data-id="element-117">
          <p data-id="element-118">
            &copy; {new Date().getFullYear()} Uzoma Towing. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}